import { useEffect } from 'react';

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', description);
    }
    return () => {
      document.title = 'Advisory Circle \u2014 Copper & Vine Studio';
    };
  }, [title, description]);
};
